
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/requests/production",
      function () {
        return require("private-next-pages/requests/production/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/requests/production"])
      });
    }
  